<template>
  <BaseTableView :head="tableHead">
    <EmployeesListItem v-for="(employee, key) in employees" :key="key" :employee="employee" />
  </BaseTableView>
</template>

<script>
import EmployeesListItem from 'components/employees/EmployeesListItem'

export default {
  name: 'EmployeesTable',
  props: ['employees'],
  components: {
    EmployeesListItem,
  },
  data: () => ({
    dialog: false,
    search: '',
  }),
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-users'].tables['familiya-imya'],
        },
        {
          text: this.localStorage.translations.pages['setting-users'].tables['elektronnaya-pochta'],
        },
        {
          text: this.localStorage.translations.pages.personnel_department['employees-group_tables'][
            'dolzhnost'
          ],
        },
        {
          text: this.localStorage.translations.pages.sales_project['planned_resources-labels'][
            'podrazdelenie'
          ],
        },
        // {
        //     text: this.localStorage.translations.pages['setting-users'].tables['rol'],
        // },
        // {
        //     text: this.localStorage.translations.pages['setting-users'].tables['sotrudnik'],
        // },
        // {
        //     text: this.localStorage.translations.pages['setting-users'].tables['offer'],
        // },
        // {
        //     text: '',
        // },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() td {
  &:nth-child(1) {
    width: 25%;
  }
  &:nth-child(2) {
    width: 25%;
  }
  &:nth-child(3) {
    width: 25%;
  }
  &:nth-child(4) {
    width: 25%;
  }
}
</style>
